export default __webpack_public_path__ + "maps-examples-runtime-toggle-layer-thumbnail-480-1095b9a74e17beb4f9e04353a270eb4d.webp";